import React from "react";
import ContactImg from "../images/contact_left.png";
import Envelope from "../icons/envelope.svg";
export default function Contact() {
  return (
    <section className="contact_section mt-5" id="contact">
      <div className="contact_container">
        <div className="row">
          <div className="col-md-6">
            <img src={ContactImg} className="contact-img" alt="" />
          </div>
          <div className="col-md-6">
            <div className="contact-info">
              <div className="d-flex">
                <img src={Envelope} alt="" />
                <div className="ml-4 d-flex flex-column">
                  <p className="mail-us">Mail me for any enquiry at</p>
                  <p className="mail"><a href="mailto:yashpurohit763@gmail.com">yashpurohit763@gmail.com</a></p>
                </div>
              </div>
              <div className="enter-name mt-5">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Name"
                />
              </div>
              <div className="enter-email mt-5">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter Your Email"
                />
              </div>
              <div className="enter-subject mt-5">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Subject"
                />
              </div>
              <div className="enter-message mt-5">
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Message"
                ></textarea>
              </div>
              <div className="btn-send mt-5">
                <button className="btn">SEND</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
